<p-dialog [contentStyle]="{'overflow':'visible', 'min-height':'35vh'}" 
            [styleClass]="'sm:col-12 md:col-6 lg:col-5 xl:col-4'" [(visible)]="visible" [modal]="true" [closable]="true" (onHide)="close($event)">
    <ng-template pTemplate="header">
        <span class="p-dialog-title">           
            {{'Stat' | translate}}
        </span>
    </ng-template>

    <p-dropdown [options]="statList" [(ngModel)]="selectedStat" [required]="true" placeholder="{{'Sel_Stat' | translate}}" [style]="{'width':'100%'}">
    </p-dropdown>

    <ng-template pTemplate="footer">
        <button class="margin" pButton type="button" (click)="onClickStat()" label="{{'Run' | translate}}"></button>
    </ng-template>
</p-dialog>
